import {TF} from '../../../constants/Common';

export const returnFilter = (record: any, value: any): boolean => {
  return record[TF].map((item: any) => {
    return item?.timeFrame;
  }).includes(value);
};

export const isValueOrNot = (value: string | number): string => {
  if (typeof value === 'string') {
    return `${value === '' ? '-' : value}`;
  } else {
    return `${value ?? '-'}`;
  }
};
